var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResultListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    width: "18px",
    height: "18px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#4b4b4b;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "20-List",
    id: "_20-List"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 6,
    width: 6,
    x: 1,
    y: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 6,
    width: 6,
    x: 1,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 6,
    width: 6,
    x: 1,
    y: 25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    x2: 32,
    y1: 2,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    x2: 20,
    y1: 6,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    x2: 32,
    y1: 14,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    x2: 20,
    y1: 18,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    x2: 32,
    y1: 26,
    y2: 26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    x2: 20,
    y1: 30,
    y2: 30
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultListIcon);
export default __webpack_public_path__ + "static/media/result-list-icon.981819d217fb70d3b1d17bb472da43c9.svg";
export { ForwardRef as ReactComponent };